import React, { Component } from 'react';
import wechat from '../wechat.jpg';

class Bottom extends Component {
  render() {
    return (
      <div>
      <footer className="footer">
        <p>
        <img src={wechat} alt="我的微信二维码" width="60" />&nbsp;&nbsp;
        <b>联系开发者!</b>&nbsp;
        E-mail:&nbsp;fanzhh@gmail.com 
        QQ&Wechat:&nbsp;403767822&nbsp;
        </p>
      </footer>
    </div>
    )
  }
}


export default Bottom;



// WEBPACK FOOTER //
// ./src/components/Bottom.js